var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timezone && _vm.currentFormat)?_c('div',{staticClass:"small m-auto"},[_c('span',{staticClass:"small"},[_vm._v(_vm._s((_vm.currentFormat + " " + _vm.offset + " " + _vm.timezone)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }